import { ReactNode } from "react";

/**
 * Banner priority levels
 */
export enum BannerPriority {
  critical = "critical",
  high = "high",
  information = "information",
  activity = "activity"
}

/**
 * Banner component props
 */
export interface BannerProps {
  /** Priority level of the banner */
  priority?: keyof typeof BannerPriority;
  /** Content to display in the banner */
  text: ReactNode;
  /** Component to handle closing the banner */
  closeBanner?: ReactNode;
  /** Additional CSS class name */
  className?: string;
  /** Whether to show icons in the banner */
  includeIcons?: boolean;
}
